import { useState, useEffect } from "react";

export function useAppConfig() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchConfig() {
      try {
        const response = await fetch('/config.json');
        if (!response.ok) throw new Error(`Failed to fetch config: ${response.status}`);
        const data = await response.json();
        setConfig(data);
      } catch (e) {
        setError(e.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    }
    fetchConfig();
  }, []);

  return { config, loading, error };
}
